
































































import {
  defineComponent, computed, PropType, ref, ComputedRef,
} from '@vue/composition-api';
import NavigationLink from '~/components/NavigationLink.vue';
import MobileDrawerCarousel from './MobileDrawerCarousel.vue';
import { INavigationTab, ISlides } from './types';

export default defineComponent({
  name: 'MobileDrawerSection',
  props: {
    section: {
      type: Object as PropType<INavigationTab>,
      required: true,
    },
    isLastSection: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MobileDrawerCarousel,
    NavigationLink,
  },
  setup(props) {
    const isActive = ref(false);
    const isValid = computed(() => Object.keys(props.section).length !== 0);

    function isSubSection(section: INavigationTab) {
      return section?.content[0]?.component === 'NavigationSubSection';
    }

    const getSlides = computed(() => props.section.content.find((link) => link.slides)?.slides) as ComputedRef<ISlides[]>;

    return {
      isSubSection,
      isActive,
      getSlides,
      isValid,
    };
  },
});
